import { UserNotification } from '@/models/UserNotification';
import { UserNotificationConfig } from '@/models/UserNotificationConfig';
import { defineStore } from 'pinia'

interface NotificationState {
    notifications:  UserNotification[];
    config:         UserNotificationConfig[];
}

export const useNotificationStore = defineStore('notification', {
  
    state: () : NotificationState => ({
        notifications:  [],
        config:         []
    }),
    actions: {
        setList(notifications: UserNotification[]){
            this.notifications = notifications;
        },    
        setConfig(config: UserNotificationConfig[]){
            this.config = config;
        },
        clear(){
            this.notifications =  [];
            this.config =         [];            
        },        
    },
    getters: {
        getNotifications: (state): UserNotification[]  => {
            return state.notifications;
        },
        getConfig: (state): UserNotificationConfig[]  => {
            return state.config;
        }
    }
});